import Application from "../../Application";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import OrganisationIndexByDateReportPresenter, {
  IOrganisationIndexByDateReportPresenter
} from "../presenter/OrganisationIndexByDateReportPresenter";

export default class ShowOrganisationIndexByDateReportInteractor {
  private application: Application;
  private output?: IOrganisationIndexByDateReportPresenter;
  private getAllOrganisations: GetAllOrganisationsInteractor;

  constructor({ application, getAllOrganisations }: any) {
    this.application = application;
    this.getAllOrganisations = getAllOrganisations;
  }

  private async getOrganisations() {
    return this.getAllOrganisations.execute();
  }

  private async getReferenceLists() {
    return Promise.all([this.getOrganisations()]);
  }

  execute() {
    this.output = OrganisationIndexByDateReportPresenter({
      application: this.application,
      initialState: {
        selectedCategoryId: NaN,
        organisations: [],
        indexCategories: [],
        dateIncluded: undefined,
        data: []
      }
    });
    this.getReferenceLists().then(([organisations]) => {
      this.output?.loadReferenceValues(organisations);
    });
    return this.output;
  }
}
